import angular from 'angular';
import BlndTable from 'app/common/table';

import addModalTpl from './templates/add.modal.html';
import editModalTpl from './templates/edit.modal.html';
import changePasswordModalTpl from './templates/change.password.modal.html';

class EditUserModalCtrl {

    constructor (R, $uibModalInstance, $state, object) {
        "ngInject";
        this.object = object;
        this.R = R;
        this.data = this.R.copy(object);
        this.$state = $state;
        this.$modal = $uibModalInstance;
    }

    get title () {
        return `Edit ${this.object.username}`;
    }

    close () {
        this.$modal.dismiss();
    }

    submit () {
        let self = this;
        this.data.put().then(
            function(data){
                angular.extend(self.object, data);
                self.$state.go('r.in.top.admin.users.list.user', {objectId: data.id}, {reload: true});
                self.$modal.close(data.id);
            },
            function(resp) {
                self.errors = resp.data;
            },
        ).finally(() => self.loading = false);
    }
}

export class UserListCtrl {

    constructor (NgTableParams, Modal, $growl, $state, $stateParams, UserStore) {
        "ngInject";

        this.Modal = Modal;
        this.$growl = $growl;
        this.$state = $state;
        this.selectedObject = $stateParams.objectId;

        this.defaultParams = {
            role: 3,
            page_size: 20
        };

        this.resetParams();

        this.table = new BlndTable(
            NgTableParams, UserStore,
            {
                defaultParams: this.defaultParams,
                params: this.params,
            }
        );

        if ($state.params && $state.params.objectId) {
            this.selectedObject = $state.params.objectId;
        }
    }

    addUser () {
        let self = this;
        let $modal = this.Modal.open({
            template: addModalTpl,
            controller: CreateUserCtrl,
        });

        $modal.result.then(function(objectId){
            self.$growl.added();
            self.$state.go('r.in.top.admin.users.list.user', {objectId: objectId});

        });
    }

    selectRow (objectId) {
        this.selectedObject = objectId;
        this.$state.go('r.in.top.admin.users.list.user', {objectId: objectId});
    }

    resetParams () {
        this.params = _.clone(this.defaultParams);
    }

    refresh () {
        return this.table.refresh(this.params);
    }
}

class CreateUserCtrl {

    constructor ($uibModalInstance, UserStore) {
        "ngInject";

        this.$modal = $uibModalInstance;
        this.store = UserStore;
        this.data = {
            'is_active': false,
        };
    }

    get title () {
        return `Create new user`;
    }

    close () {
        this.$modal.dismiss();
    }

    submit () {
        let self = this;
        self.loading = true;
        this.store.create(this.data).then(
            function(data){
                self.$modal.close(data.id);
            },
            function(resp) {
                self.errors = resp.data;
            },
        ).finally(() => self.loading = false);

    }

}


class ChangePasswordCtrl {

    constructor ($uibModalInstance, object) {
        "ngInject";

        this.$modal = $uibModalInstance;
        this.object = object;
        this.data = {};
    }

    get title () {
        return `Change password for ${this.object.username}`;
    }

    close () {
        this.$modal.dismiss();
    }

    submit () {
        let self = this;
        self.loading = true;
        self.object
            .one('password')
            .post('change', self.data)
            .then(
                () => {
                    self.$modal.close();
                },
                (response) => {
                    self.errors = response.data;
                }
            )
            .finally(() => self.loading = false);
    }
}


export class UserCtrl {

    constructor ($rootScope, Modal, $growl, $object) {
        "ngInject";
        this.object = $object;
        this.$growl = $growl;
        this.Modal = Modal;
        $rootScope.object = this.object;
    }

    editModal () {
        let self = this;
        let $modal = this.Modal.open({
            template: editModalTpl,
            controller: EditUserModalCtrl,
            resolve: {
                object: () => self.object,
            }
        });

        $modal.result.then(function(){
            self.$growl.updated();
        });
    }

    editPasswordModal () {
        let self = this;
        let $modal = this.Modal.open({
            template: changePasswordModalTpl,
            controller: ChangePasswordCtrl,
            resolve: {
                object: () => self.object,
            }
        });

        $modal.result.then(function(){
            self.$growl.updated();
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/admin/users/ctrls.js